import { FormControl, FormGroup, Validators } from '@angular/forms';

export class UserRegisterForm extends FormGroup {
  constructor() {
    super({
      email: new FormControl<string>('', {
        nonNullable: true,
        validators: [Validators.required, Validators.email],
      }),
      firstName: new FormControl<string>('', {
        nonNullable: true,
        validators: [Validators.required, Validators.minLength(3)],
      }),
      lastName: new FormControl<string>('', {
        nonNullable: true,
        validators: [Validators.required, Validators.minLength(3)],
      }),
      isIncubator: new FormControl<boolean>(false, { nonNullable: true }),
      incubatorName: new FormControl<string>('', { nonNullable: true }),
      incubatorCountry: new FormControl<string>('', { nonNullable: true }),
      incubatorCity: new FormControl<string>('', { nonNullable: true }),
    });

    this.get('isIncubator')?.valueChanges.subscribe(isIncubator => {
      const incubatorNameControl = this.get('incubatorName');
      const incubatorCountryControl = this.get('incubatorCountry');
      const incubatorCityControl = this.get('incubatorCity');

      if (isIncubator) {
        incubatorNameControl?.setValidators([Validators.required]);
        incubatorCountryControl?.setValidators([Validators.required]);
        incubatorCityControl?.setValidators([Validators.required]);
      } else {
        incubatorNameControl?.setValidators(null);
        incubatorCountryControl?.setValidators(null);
        incubatorCityControl?.setValidators(null);
      }

      incubatorNameControl?.updateValueAndValidity();
      incubatorCountryControl?.updateValueAndValidity();
      incubatorCityControl?.updateValueAndValidity();
    });
  }
}
